<template>
  <div>
    <div
      class="flex items-center justify-center leading-none rounded-md border cursor-pointer shadow-sm bg-transition"
      :class="!state?'hover:bg-gray-100':'bg-gray-700 hover:bg-gray-600 border-white'"
      style="padding: 4px 4px 2px 4px"
      @click="state = !state"
    >
      <i
        class="far fa-check text-white text-xs leading-none"
        :class="!state?'opacity-0':''"
      />
    </div>
  </div>
</template>

<script>
export default {

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: undefined,
    },
  },

  data() {
    return {
      state: false,
    };
  },

  watch: {
    state() {
      this.$emit('change', {
        item: this.item,
        state: this.state,
      });
    },
  },

  mounted() {
    this.state = this.value;
  },
};
</script>

<style>
  .bg-transition {
    -webkit-transition: background-color 150ms linear;
    -ms-transition: background-color 150ms linear;
    transition: background-color 150ms linear;
  }
</style>
